const common = {
  nav_home: 'Startseite',
  nav_about_turkey: 'Über die Türkei',
  nav_turkey_culture: 'Kultur in der Türkei',
  nav_health_institutions: 'Gesundheitseinrichtungen',
  nav_agencies: 'Gesundheitstourismusagenturen',
  nav_contact: 'Kontakt',

  nav_login: 'Anmelden',
  nav_register: 'Registrieren',
  nav_user_login: 'Benutzeranmeldung',
  nav_user_login_desc: 'Auf Mitgliederbereich zugreifen',
  nav_institution_login: 'Einrichtungsanmeldung',
  nav_institution_login_desc: 'Auf Einrichtungsbereich zugreifen',
  nav_admin_login: 'Admin-Anmeldung',
  nav_admin_login_desc: 'Plattformverwaltung',
  nav_my_panel: 'Mein Bereich',
  nav_institution_panel: 'Einrichtungsbereich',
  nav_admin_panel: 'Adminbereich',
  nav_user_panel: 'Benutzerbereich',
  nav_institution_label: 'Einrichtung',
  nav_admin_label: 'Admin',
  nav_user_label: 'Benutzer',
  nav_logout: 'Abmelden',
  nav_warning_title: 'WICHTIGER HINWEIS',
  nav_warning_text: 'Health Travel Türkiye Platform ist eine digitale Plattform, die Menschen, die Gesundheitsdienstleistungen benötigen, mit Gesundheitseinrichtungen und Gesundheitstourismusagenturen zusammenbringt, die internationale Gesundheitsdienstleistungen anbieten. Auf dieser Plattform werden Gesundheitstourismusdienstleistungen angeboten. Gesundheitseinrichtungen sind von den zuständigen Behörden des jeweiligen Landes zertifiziert und autorisiert. Diese Plattform dient nur zu Informationszwecken und enthält keine medizinische Diagnose, Behandlungsempfehlungen oder Gesundheitsberatung. Der Plattformbetreiber hat keine kommerzielle oder medizinische Haftung. Bitte konsultieren Sie einen Facharzt bei Gesundheitsproblemen.',

  footer_description: 'Zugang zu genehmigten Gesundheitseinrichtungen, die vom türkischen Gesundheitsministerium autorisiert sind. Werden Sie sicher und schnell gesund.',
  footer_quick_links: 'Schnelllinks',
  footer_for_institutions: 'Für Einrichtungen',
  footer_institution_login: 'Einrichtungsanmeldung',
  footer_register: 'Registrieren',
  footer_contact: 'Kontakt',
  footer_email_label: 'E-Mail',
  footer_address_label: 'Adresse',
  footer_address_value: 'Istanbul, Türkei',
  footer_rights: 'Alle Rechte vorbehalten.',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_kvkk: 'KVKK-Aufklärungstext',
  footer_terms: 'Nutzungsbedingungen',
  footer_powered: 'Powered by Readdy',
  footer_newsletter_title: 'Bleiben Sie informiert',
  footer_newsletter_desc: 'Abonnieren Sie, um die neuesten Nachrichten über Gesundheitstourismus in der Türkei zu erhalten.',
  footer_newsletter_placeholder: 'Ihre E-Mail-Adresse',
  footer_newsletter_btn: 'Abonnieren',
  footer_newsletter_sending: 'Wird gesendet...',
  footer_newsletter_success: 'Danke! Sie wurden angemeldet.',
  footer_newsletter_error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',

  loading: 'Wird geladen...',
  search: 'Suchen',
  filter: 'Filter',
  clear: 'Löschen',
  clear_all: 'Alle löschen',
  all: 'Alle',
  view_all: 'Alle anzeigen',
  view_details: 'Details anzeigen',
  explore: 'Erkunden',
  back: 'Zurück',
  save: 'Speichern',
  cancel: 'Abbrechen',
  submit: 'Absenden',
  send: 'Senden',
  sending: 'Wird gesendet...',
  success: 'Erfolg',
  error: 'Fehler',
  no_results: 'Keine Ergebnisse gefunden',
  approved: 'Genehmigt',
  pro_member: 'PRO',
  doctor_count: '{{count}} Arzt',
  verified: 'Verifiziert',
  accreditation: 'Akkreditierung',
  official_accreditation: 'Offizielle Akkreditierung & Garantie',
  health_turkey: 'Health Türkiye',
  health_turkey_desc: 'Gesundheitstourismusplattform',
  ministry_health: 'Republik Türkei Gesundheitsministerium',
  ministry_health_desc: 'Genehmigte Gesundheitseinrichtung',
  ministry_culture: 'Republik Türkei Ministerium für Kultur und Tourismus',
  ministry_culture_desc: 'Gesundheitstourismus-Genehmigungszertifikat',
  user_type: 'Benutzer',
  institution_type: 'Einrichtung',
  admin_type: 'Admin',

  // Breadcrumb names (Schema.org JSON-LD)
  breadcrumb_home: 'Startseite',
  breadcrumb_contact: 'Kontakt',
  breadcrumb_institutions: 'Gesundheitseinrichtungen',
  breadcrumb_agencies: 'Gesundheitstourismusagenturen',
  breadcrumb_about_turkey: 'Über die Türkei',
  breadcrumb_turkey_culture: 'Türkische Kultur',
  breadcrumb_kvkk: 'KVKK',
  breadcrumb_privacy: 'Datenschutzrichtlinie',
  breadcrumb_terms: 'Nutzungsbedingungen',

  // SEO meta — page titles & descriptions
  seo_home_title: 'Health Travel Türkiye - Gesundheitstourismusplattform Türkei',
  seo_home_desc: 'Entdecken Sie akkreditierte Gesundheitseinrichtungen in der Türkei für internationale Patienten. Haartransplantation, Zahnbehandlung, ästhetische Chirurgie, IVF und mehr.',
  seo_turkiye_title: 'Über die Türkei - Reiseführer | Health Travel Türkiye',
  seo_turkiye_desc: 'Umfassender Reiseführer über die Türkei: Städte, historische Stätten, Naturwunder und praktische Reiseinformationen.',
  seo_kultur_title: 'Türkische Kultur - Traditionen, Küche & Leben | Health Travel Türkiye',
  seo_kultur_desc: 'Entdecken Sie das reiche Kulturerbe der Türkei: Traditionen, Küche, Festivals, Hamam-Kultur, Shopping und soziales Leben.',
  seo_contact_title: 'Kontakt - Health Travel Türkiye',
  seo_contact_desc: 'Kontaktieren Sie Health Travel Türkiye. Erreichen Sie uns bei Fragen zum Gesundheitstourismus in der Türkei.',
  seo_kvkk_title: 'KVKK-Aufklärungstext - Datenschutz | Health Travel Türkiye',
  seo_kvkk_desc: 'Health Travel Türkiye Datenschutz und KVKK-Aufklärungstext.',
  seo_privacy_title: 'Datenschutzrichtlinie - Datensicherheit | Health Travel Türkiye',
  seo_privacy_desc: 'Health Travel Türkiye Datenschutzrichtlinie und Grundsätze zur Datensicherheit.',
  seo_terms_title: 'Nutzungsbedingungen - Plattformregeln | Health Travel Türkiye',
  seo_terms_desc: 'Health Travel Türkiye Nutzungsbedingungen und Benutzervereinbarung.',

  seo_institutions_title: 'Gesundheitseinrichtungen in der Türkei | Health Travel Türkiye',
  seo_institutions_desc: 'Vergleichen Sie genehmigte Gesundheitseinrichtungen in der Türkei. Finden Sie die besten Kliniken für Haartransplantation, Zahnbehandlung, ästhetische Chirurgie, IVF und mehr.',
  seo_agencies_title: 'Gesundheitstourismusagenturen | Health Travel Türkiye',
  seo_agencies_desc: 'Finden Sie Gesundheitstourismusagenturen, die Ihre medizinische Reise, Unterkunft und Reisebedürfnisse in der Türkei organisieren.',
  seo_register_title: 'Registrieren - Health Travel Türkiye beitreten',
  seo_register_desc: 'Erstellen Sie Ihr Konto bei Health Travel Türkiye. Registrieren Sie sich als Patient oder Gesundheitseinrichtung, um auf alle Funktionen zuzugreifen.',
};

export default common;
